var map = {
	"./accendifuoco.JPG": 317,
	"./bricchetti.JPG": 810,
	"./fireplace.jpg": 583,
	"./gallery/IMG_4992.JPG": 906,
	"./gallery/IMG_4993.JPG": 839,
	"./gallery/angolo-vini.JPG": 952,
	"./gallery/collage.jpg": 17,
	"./gallery/detersivi-sfusi-1.JPG": 936,
	"./gallery/detersivi-sfusi.JPG": 981,
	"./gallery/detersivi-zoom.JPG": 838,
	"./gallery/vini-bottiglia.JPG": 752,
	"./gallery/vini-sfusi.JPG": 177,
	"./legna.JPG": 4,
	"./logo-piove.png": 141,
	"./pellet.JPG": 94,
	"./rifile.JPG": 542
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 491;